import { t } from "i18next";

import { Button } from "../../../../components/Button/Button";
import {
  MfinListaEvidentiranihAkciznihMarkicaPayload,
  MfinListaEvidentiranihAkciznihMarkicaResponse,
} from "../../../../modules/ministry/ministry.types";
import { getMfinEvidentiraneMarkiceExcelColumns } from "../../../../modules/ministry/ministry.usedStamps.constants";
import { KategorijaEvidentiraneMarkice } from "../../../../modules/obligee/usedStamps/usedStamps.types";
import { writeExcel } from "../../../../utils/writeExcel";

type MinistryUsedStampsExcelExportButtonProps = {
  payload?: MfinListaEvidentiranihAkciznihMarkicaPayload;
  data?: MfinListaEvidentiranihAkciznihMarkicaResponse;
};

export const MinistryUsedStampsExcelExportButton = ({
  payload,
  data,
}: MinistryUsedStampsExcelExportButtonProps) => {
  const hasExportData = Boolean(data?.evidentiraneMarkice?.length);

  const handleExportExcel = () => {
    if (!hasExportData || !data) return;

    const kategorijaEvidentiranihMarkicaId =
      payload?.kategorijaEvidentiranihMarkicaId ??
      KategorijaEvidentiraneMarkice.ISKORISCENE_PROIZVODNJA;

    writeExcel(
      data.evidentiraneMarkice ?? [],
      getMfinEvidentiraneMarkiceExcelColumns(
        kategorijaEvidentiranihMarkicaId
      ) as Parameters<typeof writeExcel>[1],
      "lista_evidentiranih_akciznih_markica",
      `${t("COMMON.PIB")}: ${data.pib ?? ""} | ${t(
        "TABLES.NAZIV_PRIVREDNOG_SUBJEKTA"
      )}: ${data.psNaziv ?? ""}`
    );
  };

  return (
    <Button
      name="excel-export-mfin"
      onClick={handleExportExcel}
      disabled={!hasExportData}
    >
      {`${t("COMMON.IZVEZ_U")} Excel`}
    </Button>
  );
};
